import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { LoadingSpinner } from './components/LoadingSpinner';
import Home from './pages/Home';
import Landing from './pages/Landing';

// Lazy load pages
const VerseFinder = React.lazy(() => import('./pages/VerseFinder'));
const Bible = React.lazy(() => import('./pages/Bible'));
const Trivia = React.lazy(() => import('./pages/Trivia'));
const Contact = React.lazy(() => import('./pages/Contact'));
const BibleStudy = React.lazy(() => import('./pages/BibleStudy'));
const StudyDashboard = React.lazy(() => import('./pages/BibleStudy/StudyDashboard'));
const DailyMotivation = React.lazy(() => import('./pages/DailyMotivation'));
const MonthlyReadings = React.lazy(() => import('./pages/MonthlyReadings'));
const Profile = React.lazy(() => import('./pages/Profile'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const AITest = React.lazy(() => import('./pages/AITest'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const DataDeletion = React.lazy(() => import('./pages/DataDeletion'));
const Terms = React.lazy(() => import('./pages/Terms'));
const PrayerRoom = React.lazy(() => import('./pages/PrayerRoom'));
const AIIntercessor = React.lazy(() => import('./pages/AIIntercessor'));
const Pray4Me = React.lazy(() => import('./pages/Pray4Me'));

const LoadingFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <LoadingSpinner size="lg" />
  </div>
);

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/landing" element={<Landing />} />
      
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route
          path="bible"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Bible />
            </Suspense>
          }
        />
        <Route
          path="verses"
          element={
            <PrivateRoute>
              <Suspense fallback={<LoadingFallback />}>
                <VerseFinder />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="trivia"
          element={
            <PrivateRoute>
              <Suspense fallback={<LoadingFallback />}>
                <Trivia />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="study"
          element={
            <PrivateRoute>
              <Suspense fallback={<LoadingFallback />}>
                <BibleStudy />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="study/dashboard"
          element={
            <PrivateRoute>
              <Suspense fallback={<LoadingFallback />}>
                <StudyDashboard />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="daily-motivation"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <DailyMotivation />
            </Suspense>
          }
        />
        <Route
          path="monthly-readings"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <MonthlyReadings />
            </Suspense>
          }
        />
        <Route
          path="profile"
          element={
            <PrivateRoute>
              <Suspense fallback={<LoadingFallback />}>
                <Profile />
              </Suspense>
            </PrivateRoute>
          }
        />
        <Route
          path="prayer-room"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <PrayerRoom />
            </Suspense>
          }
        />
        <Route
          path="ai-intercessor"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <AIIntercessor />
            </Suspense>
          }
        />
        <Route
          path="pray-4-me"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Pray4Me />
            </Suspense>
          }
        />
        <Route
          path="contact"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Contact />
            </Suspense>
          }
        />
        <Route
          path="privacy"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Privacy />
            </Suspense>
          }
        />
        <Route
          path="data-deletion"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <DataDeletion />
            </Suspense>
          }
        />
        <Route
          path="terms"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Terms />
            </Suspense>
          }
        />
        <Route
          path="ai-test"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <AITest />
            </Suspense>
          }
        />
        <Route
          path="404"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <NotFound />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/404\" replace />} />
      </Route>
    </Routes>
  );
}